import { EventsBySportIdRequest } from "sbtech-online-sportcontent-sportbook";
export const FilterFunctions = {
    /**
     * Check if entity is from selected sportIds
     * @param {Entity} x
     * @param {string[]} sportIds
     */
    filterBySport(x, sportIds) {
        return sportIds.indexOf(x.sportId) > -1;
    },
    /**
     * Check if event has liveStream
     * @param {Event} x
     */
    filterByLiveStream(x) {
        return this.filterByTag(x, EventsBySportIdRequest.EventTagsEnum.LiveStreaming.toString());
    },
    /**
     * Check if event has specific tag
     * @param {Event} x
     * @param {String} tag
     */
    filterByTag(x, tag) {
        return x.tags.indexOf(tag) > -1;
    },
    /**
     * Check if Event or Market is in this date/time range
     * @param {Event|Market} x
     * @param {string[]} sportIds
     * @param {Date} from
     * @param {Date} to
     */
    filterBySportAndDate(x, sportIds, from, to) {
        var eventDateTime = new Date(x.startEventDate || x.startDate);
        return this.filterBySport(x, sportIds) && (eventDateTime >= from && eventDateTime < to);
    },
    /**
     * Check if event is in favourites
     * @param {Event} x
     * @param {string[]} eventIds
     */
    filterByFavorites(x, eventIds) {
        return eventIds.indexOf(x.id) > -1;
    },
    /**
     * Check if market is from specific market types
     * @param {Market} x
     * @param {string[]} marketTypes
     */
    filterByMarketType(x, marketTypes) {
        return marketTypes.indexOf(x.marketType.id) > -1;
    }
};
//# sourceMappingURL=FilterFunctions.js.map